import React, { useMemo } from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PAGE_NOT_FOUND_ROUTE, SYSTEMS_ROUTE } from 'constants/routeNames';
import { isLogged } from 'selectors/auth.selector';

const privatePathsForAll = [SYSTEMS_ROUTE, PAGE_NOT_FOUND_ROUTE];

const accesisblePath = (path) => {
  const aviablePaths = [];
  return !!privatePathsForAll.concat(aviablePaths).find((p) => path.includes(p));
};

function AuthRequired() {
  const location = useLocation();
  const isLoggedIn = useSelector(isLogged);

  const canView = useMemo(() => accesisblePath(location.pathname), [location.pathname]);
  if (!isLoggedIn) {
    return (
      <Navigate to={`${SYSTEMS_ROUTE}?refer=${location.pathname}`} state={{ from: location }} />
    );
  }
  if (!canView) {
    return <Navigate to={PAGE_NOT_FOUND_ROUTE} />;
  }
  return <Outlet />;
}

export default AuthRequired;
